import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Typography } from 'antd';
import cn from 'classnames';

import styles from './NoResult.module.scss';

interface INoResultProps extends HTMLAttributes<HTMLDivElement> {
	type?: 'full' | 'popup';
	onNavigate?: () => void;
}

export const NoResult: FC<INoResultProps> = ({ className, type = 'full', onNavigate, ...props }) => {
	const { t } = useTranslation();

	const titleText = type === 'full' ? t("You don't have notifications yet") : t('No notifications');
	const descText =
		type === 'full'
			? t(
					'There will be notifications about joining offers, Cap extending, and joining status. But first, you need to join some offers.',
				)
			: t('There will be notifications about your actions. But first, you need to join some offers.');
	const buttonText = type === 'full' ? t('Visit Catalog') : t('Create Source');

	return (
		<div {...props} className={cn(className, styles.noResult)}>
			<Typography.Text className={styles.title} type="secondary">
				{titleText}
			</Typography.Text>

			<Typography.Text className={styles.desc} type="secondary">
				{descText}
			</Typography.Text>

			{onNavigate && (
				<Button className={styles.button} size="large" onClick={onNavigate} type="primary">
					{buttonText}
				</Button>
			)}
		</div>
	);
};
